import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";
import { UpdateRequestCategoryPayload } from "../types/research.types";

import { toast } from "sonner";

export const useUpdateRequestCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateRequestCategoryPayload) =>
      requestCategoryService.updateRequestCategory(payload),
    onSuccess: () => {
      // Invalidate request categories query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["requestCategories"] });
      toast.success("Category Updated", {
        description: "Request category updated successfully",
      });
    },
    onError: (error) => {
      console.error("Failed to update request category:", error);
      toast.error("Update Failed", {
        description: "Failed to update request category. Please try again.",
      });
    },
  });
};
